import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Grade } from "./types";

const Grades = () => {
  const { id } = useParams<{ id: string }>();
  const token = localStorage.getItem("token");

  const [grades, setGrades] = useState<Grade[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/modules/${id}/grades`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => {
        setGrades(data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error("Error al cargar calificaciones:", err);
        setIsLoading(false);
      });
  }, [id]);

  return (
    <div className="w-full mt-6">
      <h2 className="font-playfair font-bold text-3xl sm:text-4xl mb-4">Calificaciones</h2>

      {isLoading ? (
        <p className="px-4 sm:px-12 text-sm">Cargando calificaciones...</p>
      ) : grades.length > 0 ? (
        <>
          <div className="hidden sm:flex flex-row justify-between px-4 sm:px-12 pb-2">
            <p className="font-bold font-sourceSans">Estudiante</p>
            <p className="font-bold font-sourceSans">Calificación</p>
          </div>
          <div className="flex flex-col gap-3">
            {grades.map((grade, i) => (
              <div
                key={i}
                className="flex flex-col sm:flex-row sm:justify-between border-y border-gray-300 px-4 sm:px-12 py-2"
              >
                <p className="text-[#2755ee] font-sourceSans text-sm sm:text-base">{grade.studentName}</p>
                <p className={`font-sourceSans text-sm sm:text-base ${grade.score !== null && grade.score < 80 ? "text-red-600 font-semibold" : ""}`}>
                  {grade.score === null ? "Estudiante está cursando este módulo" : grade.score}
                  
                </p>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p className="px-4 sm:px-12 font-sourceSans text-sm">No hay calificaciones registradas para este módulo.</p>
      )}
    </div>
  );
};

export default Grades;

